define([
	"dojo/_base/declare"
], function(declare) {

	return declare(null, {
		_getSizeChartRevision: function(/*Context*/ctx) {
			var sizeChartRev = ctx.getNode() || ctx.getParent();
			console.assert(!!sizeChartRev, "SizeChartRevision node not found");

			return sizeChartRev;
		},

		_hasTwoDimSizeRange: function(/*Context*/ctx) {
			var sizeChartRevision = this._getSizeChartRevision(ctx);
			var sizeRange = ctx.cache.getNode(sizeChartRevision.SizeRange);
			return (sizeRange && sizeRange.IsTwoDim);
		}
	});
});